import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "45%",
    backgroundColor: "#fff",
    borderRadius: theme.spacing(1),
    boxshadow: "-2px 2px 4px 0px rgba(0, 0, 0, 0.15)",
    overflowY: "auto",
    maxHeight: "80vh",
    position: "absolute",
  },
  phoneContainer: {
    backgroundColor: "#6FA088",
    padding: theme.spacing(4),
    borderRadius: theme.spacing(1),
  },
  profileCard: {
    width: "100%",
    maxWidth: 400,
    margin: "auto",
    height: "100%",
    overflow: "hidden",
    backgroundColor: "#000", // Fallback
    color: "#fff",
    position: "relative",
    fontFamily: "'Helvetica Neue', sans-serif",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
  },
  banner: {
    "& img": {
      width: "100%",
      height: 180,
      objectFit: "cover",
      display: "block",
    },
  },
  bannerOverlayText: {
    position: "absolute",
    top: 50,
    width: "100%",
    textAlign: "center",
    color: "white",
    fontWeight: "bold",
    zIndex: 5,
    textShadow: "0px 0px 4px rgba(0,0,0,0.8)",
    fontSize: "32px",
  },
  avatarWrapper: {
    position: "absolute",
    top: 120,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10,
  },
  avatar: {
    width: 100,
    height: 100,
    borderRadius: 9999,
    border: "4px solid #fff",
    objectFit: "cover",
  },
  placeholder: {
    opacity: 0.5,
    border: "none",
  },
  content: {
    padding: "80px 20px 24px", // Leave space for the avatar
    backgroundColor: "#111",
    borderTop: "1px solid #222",
    borderRadius: theme.spacing(1),
    marginTop: -20, // Pull it up over the banner
    height: "100%",
  },
  membership: {
    display: "flex",
    justifyContent: "center",
    columnGap: theme.spacing(8),
    alignItems: "center",
    background: "#1e1e1e",
    padding: "10px 16px",
    margin: "12px 0",
    fontSize: 16,
    fontWeight: "bold",
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
    border: "1px solid #fff",
    borderRadius: theme.spacing(1),
  },
  price: {
    color: "#fff",
  },
  specialties: {
    "& ul": {
      paddingLeft: 20,
      margin: "8px 0",
    },
  },
  about: {
    "& p": {
      marginTop: 4,
      color: "#bbb",
      lineHeight: 1.5,
    },
  },
}));

export default useStyles;
